"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A = exports.setLinkProps = void 0;

var _react = _interopRequireDefault(require("react"));

var _router = require("./router");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Accepts HTML `a`-tag properties, requiring `href` and optionally
 * `onClick`, which are appropriately wrapped to allow other
 * frameworks to be used for creating `hookrouter` navigatable links.
 *
 * If `onClick` is supplied, then the navigation will happen before
 * the supplied `onClick` action!
 *
 * @example
 *
 * &lt;MyFrameworkLink what="ever" {...useLink({ href: '/' })}&gt;
 *   Link text
 * &lt;/MyFrameworkLink&gt;
 *
 * @param {Object} props Requires `href`. `onClick` is optional.
 */
var setLinkProps = function setLinkProps(props) {
  var onClick = function onClick(e) {
    if (!e.shiftKey && !e.ctrlKey && !e.altKey) {
      e.preventDefault(); // prevent the link from actually navigating

      (0, _router.navigate)(e.currentTarget.href);
    }

    if (props.onClick) {
      props.onClick(e);
    }
  };

  var href = props.href.substr(0, 1) === '/' ? (0, _router.getBasepath)() + props.href : props.href;
  return _objectSpread({}, props, {
    href: href,
    onClick: onClick
  });
};
/**
 * Accepts standard HTML `a`-tag properties. `href` and, optionally,
 * `onClick` are used to create links that work with `hookrouter`.
 *
 * @example
 *
 * &lt;A href="/" target="_blank"&gt;
 *   Home
 * &lt;/A&gt;
 *
 * @param {Object} props Requires `href`. `onClick` is optional
 */


exports.setLinkProps = setLinkProps;

var A = function A(props) {
  return _react.default.createElement("a", setLinkProps(props));
};

exports.A = A;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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